import {
  useAsyncCall,
  AsyncCallArgs,
  GridContainer,
  GridItem,
  InputFormField,
  SubmitFormButton,
  handleFormSubmission,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { SubGroupDetails } from "../../../../../../types/sitemapTypes";
import { createSubGroupValidationSchema } from "../../../../../../yup/schema/sitemap/sitemapValidationSchema";
import { useTranslation } from "react-i18next";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { toast } from "react-toastify";
import { createSitemapSubGroup, updateSitemapSubGroup } from "../../../../../../axios/api/services";
import { addViewObject } from "../../../../../../store/redux/slice/ViewData/viewDataPage";
import { VIEW_TYPES } from "../../../../../../config/view/types";
import React, { Fragment } from "react";

const SitemapSubGroupDialogBody = ({ setOpen, isEditMode, editingSubGroup }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const dispatch = useAppDispatch();

  const { methods } = useReactHookForm<SubGroupDetails>({
    defaultValues: editingSubGroup,
    validationSchema: createSubGroupValidationSchema,
  });

  const submit = (values) => {
    const asyncSaveSubGroup: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: values.id !== "" ? updateSitemapSubGroup(values) : createSitemapSubGroup(values),
      reactHooksForm: { methods },
      onSuccess: (response) => {
        setOpen(false);
        const viewType = VIEW_TYPES.SITEMAP_EDIT;
        const payload = { viewType, data: response };
        dispatch(addViewObject(payload));
        toast.success(t("m.save.data.success"));
      },
    };
    asyncCall(asyncSaveSubGroup);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleFormSubmission({ methods, onSubmitFn: submit, t })}>
        <GridContainer spacing={4}>
          {isEditMode && (
            <Fragment>
              <GridItem sm={3} md={3}>
                <InputFormField isDisabled={true} required={true} fieldName={"id"} labelCode={"l.input.sitemap.id"} />
              </GridItem>
              <GridItem sm={3} md={3}>
                <InputFormField required={true} fieldName={"name"} labelCode={"l.input.sitemap.subgroup.name"} />
              </GridItem>
              <GridItem sm={3} md={3}>
                <InputFormField required={true} fieldName={"nameEn"} labelCode={"l.input.sitemap.subgroup.nameEn"} />
              </GridItem>
              <GridItem sm={3} md={3}>
                <InputFormField required={true} fieldName={"position"} labelCode={"l.input.sitemap.position"} />
              </GridItem>
            </Fragment>
          )}

          {!isEditMode && (
            <Fragment>
              <GridItem sm={4} md={4}>
                <InputFormField required={true} fieldName={"name"} labelCode={"l.input.sitemap.subgroup.name"} />
              </GridItem>
              <GridItem sm={4} md={4}>
                <InputFormField required={true} fieldName={"nameEn"} labelCode={"l.input.sitemap.subgroup.nameEn"} />
              </GridItem>
              <GridItem sm={4} md={4}>
                <InputFormField required={true} fieldName={"position"} labelCode={"l.input.sitemap.position"} />
              </GridItem>
            </Fragment>
          )}
        </GridContainer>
        <GridContainer spacing={2}>
          <GridItem sm={12} md={12}>
            <Typography align={"right"}>
              <SubmitFormButton
                label={isEditMode ? "l.btn.edit.subgroup" : "l.btn.create.subgroup"}
                color={"success"}
              />
            </Typography>
          </GridItem>
        </GridContainer>
      </form>
    </FormProvider>
  );
};

export default SitemapSubGroupDialogBody;
